export const ADDON_PRODUCT_BASE_TYPE = "base";
export const ADDON_PRODUCT_DWH_TYPE = "dwh";
export const ADDON_PRODUCT_DWH_RENT_TYPE = "dwh-rent";
export const ADDON_PRODUCT_TRANSFORMS_BASIC_TYPE = "transforms-basic";
export const ADDON_PRODUCT_TRANSFORMS_BASIC_METERED_TYPE =
  "transforms-basic-metered";
export const ADDON_PRODUCT_TRANSFORMS_ADVANCED_TYPE = "transforms-advanced";
export const ADDON_PRODUCT_TRANSFORMS_ADVANCED_METERED_TYPE =
  "transforms-advanced-metered";
export const ADDON_PRODUCT_ETL_CONNECTIONS_TYPE = "etl-connections";
export const ADDON_PRODUCT_PRODUCT_ANALYTICS_TYPE = "product-analytics";
// Granted through the internal tools API; the store deliberately offers no
// control for it, though harbormaster would let a customer cancel it.
export const ADDON_PRODUCT_PRODUCT_ANALYTICS_FREE_TYPE =
  "product-analytics-free";
export const ADDON_PRODUCT_METABASE_AI_TYPE = "metabase-ai";
export const ADDON_PRODUCT_METABASE_AI_TIERED_TYPE = "metabase-ai-tiered";
export const ADDON_PRODUCT_METABASE_AI_MANAGED_TYPE = "metabase-ai-managed";
// DEPRECATED: Don't add this add-on to any new subscriptions.
// (We keep it only so we can hide it from customers until it is truly gone.)
export const ADDON_PRODUCT_SEMANTIC_SEARCH_TYPE = "semantic-search";

export const ADDON_PRODUCT_STORAGE_TYPES = [
  ADDON_PRODUCT_DWH_TYPE,
  ADDON_PRODUCT_DWH_RENT_TYPE,
] as const;

export const ADDON_PRODUCT_TRANSFORMS_TYPES = [
  ADDON_PRODUCT_TRANSFORMS_BASIC_TYPE,
  ADDON_PRODUCT_TRANSFORMS_BASIC_METERED_TYPE,
  ADDON_PRODUCT_TRANSFORMS_ADVANCED_TYPE,
  ADDON_PRODUCT_TRANSFORMS_ADVANCED_METERED_TYPE,
] as const;

export const ADDON_PRODUCT_TYPES = [
  ...ADDON_PRODUCT_TRANSFORMS_TYPES,
  ADDON_PRODUCT_DWH_TYPE,
  ADDON_PRODUCT_DWH_RENT_TYPE,
  ADDON_PRODUCT_ETL_CONNECTIONS_TYPE,
  ADDON_PRODUCT_PRODUCT_ANALYTICS_TYPE,
  ADDON_PRODUCT_PRODUCT_ANALYTICS_FREE_TYPE,
  ADDON_PRODUCT_METABASE_AI_TYPE,
  ADDON_PRODUCT_METABASE_AI_TIERED_TYPE,
  ADDON_PRODUCT_METABASE_AI_MANAGED_TYPE,
  ADDON_PRODUCT_SEMANTIC_SEARCH_TYPE,
  "python-execution",
  "dummy",
] as const;

const ADDON_DWH_ALIAS = "dwh";
const ADDON_DWH_YEARLY_ALIAS = "dwh-yearly";
const ADDON_DWH_RENT_ALIAS = "dwh-rent";
export const ADDON_PRODUCT_ANALYTICS_ALIAS = "product-analytics";
const ADDON_PRODUCT_ANALYTICS_FREE_ALIAS = "product-analytics-free";
const ADDON_TRANSFORMS_BASIC_ALIAS = "transforms-basic";
const ADDON_TRANSFORMS_BASIC_YEARLY_ALIAS = "transforms-basic-yearly";
const ADDON_TRANSFORMS_ADVANCED_ALIAS = "transforms-advanced";
const ADDON_TRANSFORMS_ADVANCED_YEARLY_ALIAS = "transforms-advanced-yearly";
const ADDON_ETL_CONNECTIONS_ALIAS = "etl-connections";
const ADDON_ETL_CONNECTIONS_YEARLY_ALIAS = "etl-connections-yearly";
const ADDON_METABASE_AI_FREE_ALIAS = "metabase-ai";
const ADDON_METABASE_AI_FREE_YEARLY_ALIAS = "metabase-ai-yearly";
const ADDON_METABASE_AI_TIERED_ALIAS = "metabase-ai-tiered";
const ADDON_METABASE_AI_TIERED_YEARLY_ALIAS = "metabase-ai-tiered-yearly";
const ADDON_METABASE_AI_MANAGED_ALIAS = "metabase-ai-managed";

export const ADDON_TRANSFORMS_ALIASES = [
  ADDON_TRANSFORMS_BASIC_ALIAS,
  ADDON_TRANSFORMS_BASIC_YEARLY_ALIAS,
  ADDON_TRANSFORMS_ADVANCED_ALIAS,
  ADDON_TRANSFORMS_ADVANCED_YEARLY_ALIAS,
  "advanced-transforms-self-hosted-yearly",
  "advanced-transforms-self-hosted",
  "transforms-basic-metered-yearly",
  "transforms-basic-metered",
  "transforms-advanced-metered-yearly",
  "transforms-advanced-metered-self-hosted-yearly",
  "transforms-advanced-metered-self-hosted",
  "transforms-advanced-metered",
] as const;

export const ADDON_ALIASES = [
  ...ADDON_TRANSFORMS_ALIASES,
  ADDON_ETL_CONNECTIONS_ALIAS,
  ADDON_ETL_CONNECTIONS_YEARLY_ALIAS,
  ADDON_METABASE_AI_FREE_ALIAS,
  ADDON_METABASE_AI_FREE_YEARLY_ALIAS,
  ADDON_DWH_ALIAS,
  ADDON_DWH_YEARLY_ALIAS,
  ADDON_DWH_RENT_ALIAS,
  ADDON_PRODUCT_ANALYTICS_ALIAS,
  ADDON_PRODUCT_ANALYTICS_FREE_ALIAS,
  ADDON_METABASE_AI_TIERED_ALIAS,
  ADDON_METABASE_AI_TIERED_YEARLY_ALIAS,
  ADDON_METABASE_AI_MANAGED_ALIAS,
  "python-execution",
  "python-execution-yearly",
  "python-execution-self-hosted",
  "python-execution-self-hosted-yearly",
  "dummy",
  "dummy-yearly",
] as const;

// Harbormaster's `product-analytics` product row carries no per-unit price
// (`default_price_per_unit` and the contracted product's `price_per_unit` are
// both 0) — the metered rate lives only in the Stripe price. Keep the
// customer-facing rate here so pricing copy and cost estimates match what is
// actually billed. Remove this once harbormaster populates the price.
export const ADDON_PRODUCT_ANALYTICS_PRICE_PER_EVENT = 0.00005; // $50 per 1M events
export const ADDON_PRODUCT_ANALYTICS_FREE_EVENTS = 1_000_000;

// Storage's published per-row rate. Belongs to `dwh-rent`, not to Track — Track's
// pricing copy quotes it because enabling Track also enables Storage. Harbormaster
// does carry this one, so it's only a fallback for the `dwh-rent` catalogue row
// being missing from `/addons`.
export const ADDON_DWH_RENT_PRICE_PER_ROW = 0.000002; // $2 per 1M rows / month
export const ADDON_DWH_RENT_FREE_ROWS = 1_000_000;

// Harbormaster's contracted-product row carries `price_per_unit` as optional and
// nullable, so a managed-AI subscription can reach us without a rate and render
// the token cost as NaN. Mirror the product's `default_price_per_unit`.
export const ADDON_METABASE_AI_MANAGED_PRICE_PER_TOKEN = 0.00000375; // $3.75 per 1M tokens

export const ADDON_PRODUCT_DWH_PREPAID_UNITS_DEFAULT = 500000;
export const ADDON_PRODUCT_DWH_PREPAID_UNITS_MIN =
  ADDON_PRODUCT_DWH_PREPAID_UNITS_DEFAULT;

export const ADDON_PRODUCT_AI_PREPAID_UNITS_DEFAULT = 500;

export const ADDON_PRODUCT_TRANSFORMS_DEFAULT =
  ADDON_PRODUCT_TRANSFORMS_BASIC_TYPE;

export const ADDON_PRODUCT_DEPLOYMENT_TYPES = [
  "all",
  "hosting",
  "selfhosted",
] as const;
